import { RevenueOpportunityRecipientPresetsTableActions } from "routes/revenue_opportunity_recipient_presets/RevenueOpportunityRecipientPresetsTableActions";

export const getRevenueOpportunityRecipientPresetsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 250,
    },
    {
      header: "Recipients",
      id: "Recipients",
      accessorKey: "info.recipients",
      enableSorting: false,
      cell: ({ row }) => {
        const value = row.original?.info?.recipients;
        return value && value.length > 0
          ? value.map(({ name }) => name).join(", ")
          : "--";
      },
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <RevenueOpportunityRecipientPresetsTableActions
          original={row.original}
        />
      ),
    },
  ];
};

export const getRevenueOpportunityRecipientPresetsTableFilters = () => {
  return [];
};
